import React, {FC} from 'react';
import classNames from 'classnames';
import {PostText} from 'components/blog/PostText';
import {format} from 'date-fns';
import {Link} from 'gatsby';
import {GatsbyImage, IGatsbyImageData} from 'gatsby-plugin-image';

import './index.scss';

export interface PostCardProps {
	className?: string
	featured?: boolean

	slug: string
	title: string
	topics: string[]
	featuredTopic?: string

	date: Date
	minutes: number
	image: {
		alt: string
		image: IGatsbyImageData
	};

	markdown?: string
}

const PostCard: FC<PostCardProps> = ({
	className,

	slug,
	title,
	date,
	minutes,
	image,

	featured,
	markdown,
}) => {
	const link = `/blog/post/${slug}`;
	const dateLabel = format(date, 'dd MMM');
	const durationLabel = `${minutes} mins read`;

	return (
		<Link
			to={link}
			className={classNames({
				'post-card': true,
				[className || '']: Boolean(className),
				'featured': featured,
			})}
		>
			<GatsbyImage className='post-card-image img-fluid' {...image} />
			<div className='post-card-body'>
				{featured && (
					<div className='post-card-body-featured'>
						FEATURED ARTICLE
					</div>
				)}
				<div className='post-card-body-data'>
					<div className='post-card-body-data-date'>{dateLabel}</div>
					<div className='post-card-body-data-separator' />
					<div className='post-card-body-data-duration'>
						{durationLabel}
					</div>
				</div>
				<div className='post-card-body-title'>{title}</div>
				{featured && markdown && (
					<div className='post-card-body-description-mask'>
						<div className='post-card-body-description'>
							<PostText markdown={trim(markdown)} />
						</div>
					</div>
				)}
			</div>
		</Link>
	);
};

const trim = (md: string) => {
	const splitBy = '\n\n';
	const lines = md.split(splitBy);
	const output = [];
	const target = 6;

	// Do filtering to enable accurate min # of lines:
	// - tables
	// - headings
	// - bold starts
	// - separators
	// - images
	for (const line of lines) {
		if (
			line.includes('|') ||
			line.startsWith('#') ||
			line.startsWith('*') ||
			line.startsWith('---') ||
			line.startsWith('<x-image')
		) {
			continue;
		}

		// Change blockquotes to normal text
		if (line.startsWith('> ')) {
			output.push(line.slice(2));
		} else {
			output.push(line);
		}

		if (output.length >= target) {
			break;
		}
	}

	return output.join(splitBy);
};

export default PostCard;
